import { isPlatformBrowser } from "@angular/common";
import {
  Directive,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  inject,
  input,
  PLATFORM_ID,
} from "@angular/core";

@Directive({
  selector: "[appLandingReveal]",
  standalone: true,
})
export class LandingSectionRevealDirective implements AfterViewInit, OnDestroy {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly platformId = inject(PLATFORM_ID);
  private observer?: IntersectionObserver;

  /** Class toggled when the section enters the viewport */
  readonly appLandingReveal = input.required<string>();

  ngAfterViewInit(): void {
    const revealClass = this.appLandingReveal();
    const host = this.elementRef.nativeElement;

    if (!revealClass || !isPlatformBrowser(this.platformId)) {
      return;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      host.classList.add(revealClass);
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        host.classList.toggle(revealClass, Boolean(entry?.isIntersecting));
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" },
    );

    this.observer.observe(host);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
